import { useState, useEffect } from 'react'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { trackServiceClick } from '../lib/analytics'
import CalendlyButton from './CalendlyButton'

const AnimatedHero = () => {
  const words = ['BUILD', 'SCALE', 'SOLVE', 'DELIVER']
  const [currentWordIndex, setCurrentWordIndex] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentWordIndex((prev) => (prev + 1) % words.length)
    }, 2000)

    return () => clearInterval(interval)
  }, [words.length])

  return (
    <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-white dark:from-gray-900 dark:to-gray-800 overflow-hidden transition-colors duration-500">
      <div className="absolute inset-0 opacity-10 dark:opacity-20">
        <div className="absolute top-20 left-20 w-72 h-72 bg-primary-500 rounded-full blur-3xl animate-float"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-accent-400 rounded-full blur-3xl animate-float" style={{animationDelay: '1s'}}></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-80 h-80 bg-primary-600 rounded-full blur-3xl animate-float" style={{animationDelay: '2s'}}></div>
      </div>

      <div className="container-custom text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mb-8"
        >
          <h1 className="text-hero font-semibold text-gray-900 dark:text-white mb-4 transition-colors duration-200">
            <span className="block">DEMIRIX</span>
            <span className="block text-2xl md:text-3xl lg:text-4xl font-normal text-gray-700 dark:text-gray-300 mb-2">
              Web Development & IT Consulting in Dubai
            </span>
            <div className="text-primary-600">
              <span>WE </span>
              {/* Fixed-width container prevents CLS from different word lengths */}
              <span className="inline-block" style={{ minWidth: '180px', textAlign: 'left' }}>
                <motion.span
                  key={currentWordIndex}
                  initial={{ opacity: 0, y: 20, rotateX: -90 }}
                  animate={{ opacity: 1, y: 0, rotateX: 0 }}
                  exit={{ opacity: 0, y: -20, rotateX: 90 }}
                  transition={{
                    duration: 0.6,
                    ease: "easeInOut"
                  }}
                  className="inline-block"
                  style={{
                    transformOrigin: 'center',
                    transformStyle: 'preserve-3d'
                  }}
                >
                  {words[currentWordIndex]}
                </motion.span>
              </span>
            </div>
          </h1>
        </motion.div>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="text-body-lg md:text-xl text-gray-600 dark:text-gray-300 mb-12 max-w-3xl mx-auto transition-colors duration-200"
        >
          Full-stack IT solutions for individuals, small businesses & startups worldwide. 
          We architect digital excellence for visionary leaders across the globe.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="flex flex-col sm:flex-row gap-4 justify-center items-center"
        >
          <CalendlyButton className="text-base font-semibold px-8 py-4">
            Schedule Free Consultation
          </CalendlyButton>
          <Link 
            to="/services"
            className="btn-secondary text-base font-semibold px-8 py-4 inline-block"
            onClick={() => trackServiceClick('Hero Services Button')}
          >
            Explore Our Services
          </Link>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="mt-16"
        >
          <p className="text-sm text-gray-500 dark:text-gray-400 transition-colors duration-200">
            Trusted by Fortune 500 companies and AAA-rated enterprises worldwide
          </p>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 0.8 }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
      >
        <div className="animate-bounce">
          <svg className="w-6 h-6 text-gray-400 dark:text-gray-500 transition-colors duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
          </svg>
        </div>
      </motion.div>
    </section>
  )
}

export default AnimatedHero